// extracted by mini-css-extract-plugin
export default {"canvasWrapper":"NVBarGraph_canvasWrapper__j1SLq"};